module.exports = __webpack_public_path__ + "static/home-website-growth-img-7e584ba14cbddef61a0a5012757a3732.png";